export enum ResourceRouteURI {
  table = 'table'
}
